import { NgFor, NgIf } from '@angular/common';
import { Component, effect, Inject, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';
import { MatButtonModule } from '@angular/material/button';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatFormField } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import 'moment/locale/en-gb';
import 'moment/locale/nb';
import { LanguageSignalService } from 'src/app/core/services/language.service';
import { OptionModel } from 'src/app/shared/models/optionModel';
import { DateAccessedEnum, DateAccessedFilterConst } from '../../constant/date-accessed-filter.constant';
import { FilterDateAccessed } from '../../models/user-model';

@Component({
  selector: 'app-filter-date-accessed',
  standalone: true,
  imports: [
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatFormField,
    MatSelectModule,
    TranslateModule,
    MatRadioModule,
    MatDatepickerModule,
    MatInputModule,
    NgIf,
    NgFor,
    FormsModule,
  ],
  providers: [{ provide: MAT_DATE_LOCALE, useValue: 'en-GB' }, provideMomentDateAdapter()],
  templateUrl: './filter-date-accessed.component.html',
  styleUrl: './filter-date-accessed.component.scss',
})
export class FilterDateAccessedComponent {
  @Input()
  specificDateInput!: Date;
  @Input()
  fromDateInput!: Date;
  @Input()
  toDateInput!: Date;
  @Input()
  isOptionFilterPeriodInput!: boolean;
  optionFilter: OptionModel[] = DateAccessedFilterConst;
  selectedFilter: number = DateAccessedEnum.Specific;

  constructor(
    public dialogRef: MatDialogRef<FilterDateAccessedComponent>,
    public languageService: LanguageSignalService,
    private _adapter: DateAdapter<any>,
    @Inject(MAT_DATE_LOCALE) private _locale: string,
  ) {
    effect(() => {
      const currentLang = this.languageService.currentLanguage();
      this.changeLocale(currentLang);
    });
  }

  filter: FilterDateAccessed = new FilterDateAccessed();
  prvSpecificDateInput!: Date;
  prvFromDateInput!: Date;
  prvToDateInput!: Date;
  prvIsOptionFilterPeriodInput!: boolean;

  ngOnInit() {
    this.prvSpecificDateInput = this.specificDateInput;
    this.prvFromDateInput = this.fromDateInput;
    this.prvToDateInput = this.toDateInput;
    this.prvIsOptionFilterPeriodInput = this.isOptionFilterPeriodInput;

    const lang = localStorage.getItem('languageCulture') || 'en';
    this.changeLocale(lang);
  }
  ngAfterContentInit() {
    if (!!this.specificDateInput && !this.isOptionFilterPeriodInput) {
      this.filter.specificDate = this.specificDateInput;
      this.filter.isOptionFilterPeriod = this.isOptionFilterPeriodInput;
      this.filter.specificDate = this.specificDateInput;
      this.selectedFilter = DateAccessedEnum.Specific;
    }
    if (!!this.fromDateInput && !!this.toDateInput && this.isOptionFilterPeriodInput) {
      this.filter.toDate = this.toDateInput;
      this.filter.fromDate = this.fromDateInput;
      this.filter.isOptionFilterPeriod = this.isOptionFilterPeriodInput;
      this.filter.fromDate = this.fromDateInput;
      this.filter.toDate = this.toDateInput;
      this.selectedFilter = DateAccessedEnum.Period;
    }
  }

  changeLocale(lang: string) {
    this._locale = lang === 'en' ? 'en' : 'nb';
    this._adapter.setLocale(this._locale);
  }

  closeFilter(isFilter: boolean): void {
    if (isFilter) {
      this.dialogRef.close(this.filter);
    } else {
      this.filter.isReload = false;
      if (!this.prvIsOptionFilterPeriodInput) {
        this.filter.isOptionFilterPeriod = this.prvIsOptionFilterPeriodInput;
        this.filter.specificDate = this.prvSpecificDateInput;
      } else {
        this.filter.toDate = this.prvToDateInput;
        this.filter.fromDate = this.prvFromDateInput;
        this.filter.isOptionFilterPeriod = this.isOptionFilterPeriodInput;
      }
      this.dialogRef.close(this.filter);
    }
  }

  saveFilter(): void {
    this.closeFilter(true);
  }

  onChangeOptionFilter(data: number) {
    if (data === DateAccessedEnum.Specific) {
      this.filter.isOptionFilterPeriod = false;
    } else {
      this.filter.isOptionFilterPeriod = true;
    }
  }
}
